import { useMemo } from "react";
import { ComparisonChartData } from "@components";

const generateFakeNumber = () => Math.round(Math.random() * 100000) / 100;

export const useFakeData = (
  { enabled }: { enabled: boolean } = { enabled: true }
): { data?: ComparisonChartData[] } => {
  const data = useMemo(() => {
    if (!enabled) {
      return;
    }
    const fakeData = Array.from(Array(5)).map(() => ({
      quote: generateFakeNumber(),
      // eslint-disable-next-line react-hooks/purity
      year: Math.floor(Math.random() * (2020 - 2000) + 2000),
      eps: generateFakeNumber(),
      totalLiabilities: generateFakeNumber(),
      operatingCashflow: generateFakeNumber(),
      capEx: generateFakeNumber(),
      freeCashflow: generateFakeNumber(),
      totalEquity: generateFakeNumber(),
      netIncome: generateFakeNumber(),
      netRevenue: generateFakeNumber(),
      outstandingShares: generateFakeNumber(),
      returnOnAssets: generateFakeNumber(),
      returnOnEquity: generateFakeNumber(),
      fScore: generateFakeNumber(),
      priceToBook: generateFakeNumber(),
      priceToCashflow: generateFakeNumber(),
      priceToFreeCashflow: generateFakeNumber(),
      priceToSales: generateFakeNumber(),
      priceToEarnings: generateFakeNumber(),
    }));
    return fakeData;
  }, [enabled]);

  return { data };
};
